var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { staticClass: "form-container" }, [
    _c(
      "div",
      { staticClass: "photos-section-container" },
      _vm._l(_vm.imagesList, function(imageData) {
        return _c(
          "div",
          { key: imageData.varName },
          [
            _c("photo-field", {
              ref: "photos",
              refInFor: true,
              attrs: {
                disabled: _vm.disabled,
                "image-data": imageData,
                previousPhoto: _vm.getPhoto(imageData.varName)
              },
              on: {
                updatePhoto: function($event) {
                  return _vm.updatePhoto($event)
                },
                removePhoto: function($event) {
                  return _vm.removePhoto($event)
                }
              }
            })
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ebc1bbe8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebc1bbe8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Photos/PhotosForm.vue
// module id = null
// module chunks = 